import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  updateRoutesList: `${NAMESPACE}_QUICK_ASSIGNMENT_UPDATE_LIST`,

  assignDriver: `${NAMESPACE}_QUICK_ASSIGNMENT_ASSIGN_DRIVER`,
  assignHelper: `${NAMESPACE}_QUICK_ASSIGNMENT_ASSIGN_HELPER`,
  assignEquipment: `${NAMESPACE}_QUICK_ASSIGNMENT_ASSIGN_EQUIPMENT`,

  unassignDriver: `${NAMESPACE}_QUICK_ASSIGNMENT_UNASSIGN_DRIVER`,
  unassignHelper: `${NAMESPACE}_QUICK_ASSIGNMENT_UNASSIGN_HELPER`,
  unassignEquipment: `${NAMESPACE}_QUICK_ASSIGNMENT_UNASSIGN_EQUIPMENT`,

  updateEquipmentAssignments: `${NAMESPACE}_QUICK_ASSIGNMENT_UPDATE_EQUIPMENT_ASSIGNMENTS`,

  toggleAssignLoading: `${NAMESPACE}_QUICK_ASSIGNMENT_ASSIGN_LOADING`,

  isDraggingDriver:  `${NAMESPACE}_QUICK_ASSIGNMENT_IS_DRAGGING_DRIVER`,
  isDraggingHelper:  `${NAMESPACE}_QUICK_ASSIGNMENT_IS_DRAGGING_HELPER`,
  isDraggingEquipment:  `${NAMESPACE}_QUICK_ASSIGNMENT_IS_DRAGGING_EQUIPMENT`,
};

export const actionCreators = {
  updateRoutesList: (payload) => ({ type: actions.updateRoutesList, payload }),

  assignDriver: (payload) => ({ type: actions.assignDriver, payload }),
  assignHelper: (payload) => ({ type: actions.assignHelper, payload }),
  assignEquipment: (payload) => ({ type: actions.assignEquipment, payload }),

  unassignDriver: (payload) => ({ type: actions.unassignDriver, payload }),
  unassignHelper: (payload) => ({ type: actions.unassignHelper, payload }),
  unassignEquipment: (payload) => ({ type: actions.unassignEquipment, payload }),
  updateEquipmentAssignments: (payload) => ({ type: actions.updateEquipmentAssignments, payload }),

  toggleAssignLoading: (payload) => ({ type: actions.toggleAssignLoading, payload }),

  isDraggingDriver: (payload) => ({ type: actions.isDraggingDriver, payload }),
  isDraggingHelper: (payload) => ({ type: actions.isDraggingHelper, payload }),
  isDraggingEquipment: (payload) => ({ type: actions.isDraggingEquipment, payload }),
};

export default {
  actions,
  actionCreators
};
